import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({
    checkIn: '',
    checkOut: '',
    guests: 2,
    rooms: 1,
    roomType: 'any',
    selectedRoom: null,
  });

  const [bookings, setBookings] = useState([]);

  const updateBooking = (data) => {
    setBookingData(prev => ({ ...prev, ...data }));
  };

  const confirmBooking = (booking) => {
    const newBooking = {
      ...booking,
      id: Date.now(),
      status: 'confirmed',
      createdAt: new Date().toISOString(),
    };
    setBookings(prev => [...prev, newBooking]);
    return newBooking;
  };

  return (
    <BookingContext.Provider value={{ bookingData, updateBooking, bookings, confirmBooking }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
